module.exports = __webpack_public_path__ + "img/news3.c2b4fc4d.png";